exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rainmaker-card {\n  color: #5f5c62;\n  background-color: white;\n  -webkit-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  -o-transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: Roboto;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n          box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  border-radius: 3px;\n  z-index: 1;\n  margin: 16px 0px;\n  padding: 12px 8px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Card/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Card/index.css
// module chunks = 504